module.exports = __webpack_public_path__ + "static/media/resume.b30a9b5b.pdf";